import type { QueryFunctionContext } from "@tanstack/react-query"
import type { AxiosResponse } from "axios"

import { axiosClient } from "$/http"

import { ECoachDashboardQueryKeyBase as EKeyBase, ECoachDashboardQueryUrl as EUrl } from "./coach.dashboard.api.config"
import type {
    ICoachDashboardParticipantsQueryDto,
    ICoachDashboardSessionsQueryDto,
    ICoachSessionWithoutAttendanceMarksDto,
    TCoachDashboardQueryOrder,
    TCoachDashboardQueryPeriod
} from "./coach.dashboard.api.types"

async function attendances(): Promise<ICoachSessionWithoutAttendanceMarksDto[]> {
    const { data }: AxiosResponse<ICoachSessionWithoutAttendanceMarksDto[]> = await axiosClient.get(
        EUrl.MarkedAttendances()
    )

    return data
}

async function sessions({
    queryKey
}: QueryFunctionContext<
    [EKeyBase, string, number, TCoachDashboardQueryPeriod, TCoachDashboardQueryOrder]
>): Promise<ICoachDashboardSessionsQueryDto> {
    const [, search, page, period, order]: [
        EKeyBase,
        string,
        number,
        TCoachDashboardQueryPeriod,
        TCoachDashboardQueryOrder
    ] = queryKey

    const { data }: AxiosResponse<ICoachDashboardSessionsQueryDto> = await axiosClient.get(
        EUrl.Sessions({ search, page, order, period })
    )

    return data
}

async function participants({
    queryKey
}: QueryFunctionContext<[EKeyBase, string, number]>): Promise<ICoachDashboardParticipantsQueryDto> {
    const [, search, page]: [EKeyBase, string, number] = queryKey

    const { data }: AxiosResponse<ICoachDashboardParticipantsQueryDto> = await axiosClient.get(
        EUrl.Participants({ search, page })
    )

    return data
}

export default { attendances, sessions, participants }
